import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronDownIcon } from '@icons';
import classNames from 'classnames';
import { memo, useMemo } from 'react';
import { useFirstRender } from '../common/effects/useFirstRender';
import { isDark } from '../common/utils';
import styles from './menu-bar.module.scss';
const MenuBarItem = memo(({ active, showIcon, icon, size = 'sm', RTL = false, name, isMenuOpen }) => {
    const isDarkMode = useMemo(() => isDark(), []);
    const isFirstRender = useFirstRender();
    const menuBarItemClass = useMemo(() => classNames(styles.item, isDarkMode && styles.dark, {
        [styles.active]: active,
    }, RTL ? styles.rtl : ''), [RTL]);
    return (_jsxs("li", { className: menuBarItemClass, children: [showIcon && (_jsx("span", { className: classNames(styles.icon, styles.size), children: icon })), _jsx("span", { className: classNames(styles.name, styles[size], RTL ? styles.rtl : '', active ? styles.active : ''), children: name }), _jsx("span", { className: classNames(styles.chevron_icon, styles[size], RTL ? styles.rtl : '', isMenuOpen
                    ? styles.rotate
                    : !isFirstRender.current
                        ? styles.rotate_reverse
                        : ''), children: _jsx(ChevronDownIcon, {}) })] }));
}, (prev, next) => prev.active === next.active && prev.isMenuOpen === next.isMenuOpen);
MenuBarItem.displayName = 'MenuBarItem';
export { MenuBarItem };
